import { SectionTranslationModel } from '@/assets/locales/views/employeeProfile/sections/SectionTranslation.model.ts';

export type EmployeeProfilePotentialOverviewSectionTranslation = SectionTranslationModel<{
  actionRequired: string;
  careerPath: {
    label: string;
    nextStep: string;
    optionalStep: string;
  };
  feedback: {
    false: string;
    form: {
      cancelButton: string;
      description: string;
      label: string;
      sendNotProvidedButton: string;
      sendProvidedButton: string;
      submitNotFeedbackButton: string;
    };
    label: string;
    true: string;
  };
  potential: {
    comment: string;
    commentNotFound: string;
    label: string;
    notFound: string;
  };
}>;

export const employeeProfilePotentialOverviewSectionTranslation: EmployeeProfilePotentialOverviewSectionTranslation =
  {
    content: {
      actionRequired: 'Uzupełnij status feedbacku',
      careerPath: {
        label: 'Ścieżka kariery',
        nextStep: 'Kolejny krok',
        optionalStep: 'Opcjonalny krok',
      },
      feedback: {
        false: 'Nie udzielono',
        form: {
          cancelButton: 'Anuluj',
          description: 'Powód nieudzielenia informacji zwrotnej',
          label: 'Aktualizacja statusu informacji zwrotnej',
          sendNotProvidedButton: 'Nie udzielono',
          sendProvidedButton: 'Udzielono',
          submitNotFeedbackButton: 'Zapisz',
        },
        label: 'Status udzielenia informacji zwrotnej',
        true: 'Udzielono',
      },
      potential: {
        comment: 'Komentarz do przeglądu',
        commentNotFound: 'Brak komentarza',
        label: 'Potencjał liderski',
        notFound: 'Nie znaleziono kryteriów liderskich',
      },
    },
    headerTitle: 'Wynik Przeglądu Potencjału MDR',
    headerTitleShorter: 'Wynik Przeglądu Potencjału MDR',
  };
